import { request } from "@/utils/request2";
import {
  IP2
} from "@/services/config.js";

const CURRENT_PATIENT_DEPARTMENT_ID_KEY = 'currentPatientDepartmentId';



/**
 * 登录
 * @param {*} phoneNumber
 * @param {*} verCode
 * @returns
 */
export async function loginNew(data) {
  const resp = await request({
    url: `/sys/login`,
    method: "POST",
    data
  });
  if (resp.code === 200) {
    //console.log(resp);
    //console.log(resp.data);
  }
  return resp;
}



/**
 * 专业人员信息
 * @returns
 */
export async function getProfessionalInfo(params) {
    const resp = await request({
      url: `/ly/careProfessionals/queryById`,
      method: "GET",
      params
    });
    if (resp.code === 200) {
      //console.log(resp);
      //console.log(resp.data);   //1942895854746120194  departmentId   所属部门编号
    }
    return resp;
  }

  
/**
 * 专业人员信息[医院]  
 * @returns
 */
export async function getProfessionalHospital(params) {
    const resp = await request({
      url: `/ly/lyServiceProviders/list`,
      method: "GET",
      params
    });
    if (resp.code === 200) {
      //console.log(resp);
      //console.log(resp.data);
    }
    return resp;
  }


/**
 * 专业人员信息[科室]     //医疗信息通过子表
 * @returns
 */
export async function getProfessionalDepoartment(params) {
    const resp = await request({
      url: `/ly/lyServiceProviders/queryLyServiceDepartmentsBySubId`,
      method: "GET",
      params
    });
    if (resp.code === 200) {
      
    }
    return resp;
  }

/**
 * 专家个人设置
 * @returns
 */
export async function getProfessionalSelf(params) {
    const resp = await request({
      url: `/ly/careProfessionals/queryProfessionalSettingsByMainId`,
      method: "GET",
      params
    });
    if (resp.code === 200) {
      //console.log(resp);
      //console.log(resp.data);
    }
    return resp;
  }


  /**
 * 专家问诊个人模板，写进去的内容 [todo]
 * @returns
 */
export async function  UpdateProfessionalSelf(params) {
    const resp = await request({
      url: `/ly/careProfessionals/queryProfessionalSettingsByMainId`,
      method: "GET",
      params
    });
    if (resp.code === 200) {
      //console.log(resp);
      //console.log(resp.data);
    }
    return resp;
  }

//今日挂号，某个医生下的所有挂号信息
export async function getTodayBooking(params) {
    const resp = await request({
      url: `/ly/lyUserVisitFlowStatus/list`,
      method: "GET",
      params
    });
    return resp;
  }

  
  
//今日挂号，某个医生下的所有挂号信息
export async function getPatient_Check(params) {
  const resp = await request({
    url: `/ly/lyHealthTestReports/list`,
    method: "GET",
    params
  });
  return resp;
}


//获取某个病人的会话记录
export async function listOfPatientConversation(params) {
  const resp = await request({
    url: `/ly/lyAiChatRecords/list`,
    method: "GET",
    params
  });
  return resp;
}

export async function addOfPatientConversation(data) {
  const resp = await request({
    url: `/ly/lyAiChatRecords/add`,
    method: "POST",
    data    
  });
  return resp;
}

//获取某个病人的病历记录
export async function listOfPatientMedicalRecord(params) {
  const resp = await request({
    url: `/ly/careProfessionals/queryProfessionalSettingsByMainId`,
    method: "GET",
    params
  });
  return resp;
}
 

//个人设置-常用问题-
export async function setProfessionalSelf(params) {
  const resp = await request({
    url: `/ly/careProfessionals/queryProfessionalSettingsByMainId`,
    method: "GET",
    params
  });
  return resp;
}



//AI 引用
export async function getAiReference(data) {
  // 如果传入的 data 中包含 chatId 且不为空，则保留；否则不添加 chatId 参数
  const requestData = { ...data };
  
  // 如果 chatId 为空或无效，则移除该参数
  if (!requestData.chatId || requestData.chatId.trim() === '') {
    delete requestData.chatId;
  }

  const departmentIdFromCaller = requestData.departmentId;
  const storedDepartmentId = localStorage.getItem(CURRENT_PATIENT_DEPARTMENT_ID_KEY) || '';
  requestData.departmentId = departmentIdFromCaller || storedDepartmentId || '';
  
  // 如果 visitNum 不存在，从 localStorage 获取
  if (!requestData.visitNum) {
    requestData.visitNum = localStorage.getItem('visitNum') || '';
  }
  
  const resp = await request({
    url: `/ly/archive/add`,
    method: "POST",
    data: requestData
  });
  return resp;
}


// //AI 录音上传
// export async function postAiRecord(data) {
//   const resp = await request({
//     url: `/ly/midRecord/upload`,
//     method: "POST",
//     data
//   });
//   return resp;
// }

/**
 * 存入录音
 * @param {*} data
 * @returns
 */
export function postAiRecord(data) {
  return new Promise((resolve, reject) => {
    let formData = new FormData();
    formData.append("file", data);
    formData.append("departmentId", localStorage.getItem(CURRENT_PATIENT_DEPARTMENT_ID_KEY) || '');
    formData.append("visitNum", localStorage.getItem('visitNum') || '');
    // 创建一个AJAX请求上传文件
    const xhr = new XMLHttpRequest();
    xhr.open("POST", IP2 + "/ly/midRecord/upload", true);
    xhr.setRequestHeader("X-Access-Token", localStorage.getItem("token"));
    const tenantId = localStorage.getItem("loginTenantId");
    if (tenantId) {
      xhr.setRequestHeader("X-Tenant-Id", tenantId);
    }
    xhr.onload = async (res) => {
      if (res.currentTarget.status === 200) {
        // console.log("xhr.response++++++++++++")
        // console.log(xhr.response)
        // console.log("xhr.response++++++++++++",JSON.parse(xhr.response))
        resolve(JSON.parse(xhr.response));
        
      } else {
        reject(xhr);
        console.error("上传失败", res);
      }
    };
    xhr.send(formData);
  })
  // const formData = new FormData();
  // formData.append('formData', data); // 假设后端期望接收名为'formData'的字段
  // console.log("data", data, formData)
  // return request({
  //   url: `/public/writeFiles/create`,
  //   headers: {
  //     'Content-Type': 'multipart/form-data' // 确保设置正确的Content-Type，axios会自动设置boundary，无需手动设置
  //   },
  //   // responseType: 'blob', // 确保axios返回的是blob类型的数据
  //   method: "POST",
  //   formData,
  //   data:{},
  //   isDecrypt: false,
  //   isEncrypt: false,
  // });

}